import styled from '@emotion/styled';
import { TypographyProps } from '@material-ui/core/Typography';
import { createElement, MouseEventHandler } from 'react';

import theme from '../../../../theme';
import { itemBackground } from '../../../constant/color';
import RouterLinkBase from './RouterLinkBase';

type Props = TypographyProps & {
  type?: 'text' | 'area';
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  withNewTab?: boolean;
  className?: string;
  innerRef?: any;
};

const RouterLink = ({ type = 'text', ...props }: Props) => {
  switch (type) {
    case 'text':
      return <AnchorTypography {...props} />;
    case 'area':
      return <AnchorSection {...props} />;
    default:
      return <AnchorTypography {...props} />;
  }
};

const AnchorTypography = (styled(RouterLinkBase)({
  color: theme.palette.primary.main,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.primary.main,
    textDecoration: 'underline',
  },
  '&:active': {
    color: theme.palette.primary.main,
  },
  '&:visited': {
    color: theme.palette.primary.main,
  },
}) as unknown) as typeof RouterLinkBase;

const AnchorSection = (styled(RouterLinkBase)({
  display: 'block',
  textDecoration: 'inherit',
  color: 'inherit',
  '&:hover': {
    background: itemBackground,
    transition: 'background 0.3s ease',
  },
}) as unknown) as typeof RouterLinkBase;

export default RouterLink;
